import type { StripeConnectStatus } from '@/api/communities';

export interface ConnectReadiness {
  status?: StripeConnectStatus;
  isLoading: boolean;
  /**
   * Whether the community can collect/store payments right now. Reflects the
   * live backend state (not the cached session community object), so it stays
   * correct after a manager connects or disconnects Stripe.
   */
  isReady: boolean;
  /** Whether payments are enabled for the community (admin toggle). */
  paymentsEnabled: boolean;
}

/**
 * Pure readiness derivation from a connect-status payload. A community can only
 * collect/store payments when payments are enabled AND a connected account has
 * finished onboarding AND charges are enabled. Kept dependency-free (type-only
 * import) so it can be unit tested without the axios/React Query stack.
 */
export function deriveConnectReadiness(
  status?: StripeConnectStatus,
): Pick<ConnectReadiness, 'isReady' | 'paymentsEnabled'> {
  return {
    isReady:
      status?.payments_enabled === true &&
      status?.charges_enabled === true &&
      status?.onboarding_complete === true,
    paymentsEnabled: status?.payments_enabled === true,
  };
}
